import { Component, OnInit } from '@angular/core';
//import { FormGroup, FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { ContentAuthoringService } from "../../services/content-authoring.service";
import { AssessmentService } from "../../services/assessment.service";
import { NgbModal, ModalDismissReasons, NgbPaginationConfig, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import { CourseService } from '../../services/course.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-course-publish',
  templateUrl: './course-publish.component.html',
  styleUrls: ['./course-publish.component.scss']
})
export class CoursePublishComponent implements OnInit {
  adminData:any;courseId:any='';courseData:any;key:any='';
  constructor(private route: ActivatedRoute,
    private router: Router,
    private contentAuthoringApi: ContentAuthoringService,
    private spinner: NgxSpinnerService,
    private modalService: NgbModal,private toastr: ToastrService,private authCourse:CourseService) {}

  
  /*****get couse detail ****/
  getCourseAuthDetails(courseId:any){
    this.authCourse.CourseDetail(courseId).subscribe(
      data=>{
       // console.log(data);
        this.courseData = data.courseData
      },error=>{

      }
    )
  }
  open(content: any) {
    this.modalService.open(content, { centered: true, size: 'sm' });
  }
  cancelbk(){
    document.getElementById('CloseIds')?.click();
    
    if(this.key){
      this.router.navigate(['/courses_add_review'], { queryParams: { courseId:this.courseId } });
      //this.router.navigate(['/courses_add_assign_user'], { queryParams: { courseId:this.courseId } });
    }else{
      //this.router.navigate(['/courses_add_review'], { queryParams: { courseId:this.courseId } });
      this.router.navigate(['/courses_add_assign_user'], { queryParams: { courseId:this.courseId } }); 
    }
  }
  logout(){
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
 localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
   }
  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.route.queryParams.subscribe(queryParams => {
      this.courseId = queryParams['courseId'];
      this.key = queryParams['key'];
      //this.tab = queryParams['tab'];
    });
    if (this.courseId != '' && this.courseId != null) {
      this.getCourseAuthDetails(this.courseId);
    }
  }

}
